import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPremise } from 'src/app/entities/interfaces/configuration/IPremise';
import { getActiveCompanyId } from 'src/app/entities/constants';

@Injectable({
    providedIn: 'root'
})
export class PremiseService {

    constructor(private http: HttpClient) { }

    private getHeaders(): HttpHeaders {
        const token: string = sessionStorage.token;
        return new HttpHeaders({ 'Authorization': token });
    }

    // ─── List (POST) ────────────────────────
    List(): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/List.php");
        return this.http.post<any>(uri, { idCompany: getActiveCompanyId() }, { headers });
    }

    // ─── Load (POST) ────────────────────────
    Load(idPremise: number): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/Load.php");
        return this.http.post<any>(uri, { idPremise }, { headers });
    }

    // ─── Create (POST) ─────────────────────
    Create(row: IPremise): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/Create.php");
        return this.http.post<any>(uri, row, { headers });
    }

    // ─── Update (POST) ─────────────────────
    Update(row: IPremise): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/Update.php");
        return this.http.post<any>(uri, row, { headers });
    }

    // ─── Delete (POST) ─────────────────────
    Delete(idPremise: number): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/Delete.php");
        return this.http.post<any>(uri, { idPremise }, { headers });
    }

    // ─── Associate User (POST) ─────────────
    AssociateUser(idCompany: string, idPremise: number, userName: string): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/AssociateUser.php");
        return this.http.post<any>(uri, { idCompany, idPremise, userName }, { headers });
    }

    // ─── Disassociate User (POST) ──────────
    DisassociateUser(idCompany: string, idPremise: number, userName: string): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("premise/DisassociateUser.php");
        return this.http.post<any>(uri, { idCompany, idPremise, userName }, { headers });
    }
}
